import axios, { AxiosResponse } from 'axios';
import pathfinder from '@fiverr-private/pathfinder';
import { IntentClassificationResponse, PollingResponse } from '.';

export interface IntentClassificationRequest {
    user_input: string;
    context_id: string;
}

export const intentClassificationUrl = pathfinder('classify_intent');
export const getIntentClassificationPollingUrl = (pollingId: string) =>
    pathfinder('classify_intent_poll', { classification_id: pollingId });

export const classifyIntent = async ({
    userInput,
    context_id,
    abortController,
}: {
    userInput: string;
    context_id: string;
    abortController: AbortController;
}) =>
    axios.post<PollingResponse, AxiosResponse<PollingResponse>, IntentClassificationRequest>(
        intentClassificationUrl,
        {
            user_input: userInput,
            context_id,
        },
        {
            signal: abortController.signal,
        }
    );

export const getIntentClassification = async ({
    pollingId,
    abortController,
}: {
    pollingId: string;
    abortController: AbortController;
}) => {
    const data = await axios.get<IntentClassificationResponse>(getIntentClassificationPollingUrl(pollingId), {
        signal: abortController?.signal,
    });

    if (!data.data) {
        throw new Error('No data');
    }

    return data;
};
